module.exports = __webpack_public_path__ + "static/img/enterprenceBanner.6e05c946.png";